import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API } from 'aws-amplify';
import { ConfigService } from '../../config';
import {
	CanisterTypeState,
	normalizeCanisterTypeError
} from './canister-type.util';

export interface CanisterTypeChangeResult {
	machine_id: string;
	serial_no: string;
	desired: string;
	requested_by: string;
}

@Injectable({
	providedIn: 'root'
})
export class CanisterTypeHttpService {
	private apiName: string;

	constructor(private configService: ConfigService) {
		this.apiName = this.configService.get('host');
	}

	getCanisterType(serialNo: string): Observable<CanisterTypeState> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-canister-type/' + encodeURIComponent(serialNo);
			API.get(this.apiName, path, { response: false }).then(response => {
				observer.next(unwrapState(response));
				observer.complete();
			}).catch(error => {
				observer.error(normalizeCanisterTypeError(error));
			});
		});
	}

	setCanisterType(serialNo: string, canisterType: string): Observable<CanisterTypeChangeResult> {
		return new Observable((observer: any) => {
			API.post(this.apiName, '/dashboard/canister-type', {
				response: false,
				body: {
					serial_no: serialNo,
					canister_type: canisterType
				}
			}).then(response => {
				observer.next(unwrapState(response));
				observer.complete();
			}).catch(error => {
				observer.error(normalizeCanisterTypeError(error));
			});
		});
	}
}

function unwrapState(response: any): any {
	const payload = response && response.data;
	if (payload && typeof payload === 'object') {
		return payload;
	}
	return response;
}
